import React, { useState, useEffect, FC } from "react";
import { Link } from "react-router-dom";
import Content from "../../../layout/content/Content";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button,
  BlockDes,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  TooltipComponent,
  PaginationComponent,
} from "../../../components/Component";
import Swal from "sweetalert2";
import usersApis from "../../../api/master/users";
import UsersMaster from "./UsersMaster";
import { useNavigate } from "react-router-dom";
import FormatDate from "../DateFormater";
import Export from "../../../components/export/Export";
import { useSelector } from "react-redux";
import { Flex, Spin } from "antd";
import TransactionFlowDefaultTemplate from "../../others/transactionFlowDefaultTemplate";
import dayjs from "dayjs";
const Users: FC = () => {
  const [refreshToggle, setRefreshToggle] = useState(false);
  const { data: accessibility } = useSelector(
    (state: any) => state.accessibility
  );
  const [allowedActions, setAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });

  useEffect(() => {
    if (accessibility) {
      try {
        const { add, view, edit, approve, reject, cancel } =
          accessibility["Master"];
        setAllowedActions({ add, view, edit, approve, reject, cancel });
      } catch (error) {
        console.log(error);
      }
    }
  }, [accessibility]);

  const handleDelete = (id: any) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      allowOutsideClick: false,
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-secondary",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        deleteBuyerById(id);
      }
    });
  };
  const deleteBuyerById = async (id: any) => {
    try {
      const { status, message } = await usersApis.deleteBuyerById(id);
      if (status) {
        Swal.fire("Deleted!", "Buyer has been deleted.", "success");
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (err: any) {
      Swal.fire("Error", err.response.data.message, "error");
    } finally {
      setRefreshToggle(!refreshToggle);
    }
  };

  const navigate = useNavigate();

  const createUser = () => {
    navigate(`/createUsers`);
  };

  const columns = [
    {
      title: "Internal ID",
      dataIndex: "referenceID",
      key: "referenceID",
      width: 200,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 250,
    },
    {
      title: "Department",
      dataIndex: "departmentName",
      key: "departmentName",
      width: 250,
    },
    {
      title: "Role",
      dataIndex: "roleName",
      key: "roleName",
      width: 250,
    },
    {
      title: "Reporting Manager",
      dataIndex: "reportingManagerName",
      key: "reportingManagerName",
      width: 200,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 200,
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      width: 200,
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      width: 250,
      render: (text: any, record: any) => (
        <span>{dayjs(text).format("DD-MMM-YYYY")}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
      width: 200,
      render: (text: any, record: any) => (
        <span
          className={`tb-status text-${record.status === "Active" ? "success" : "danger"
            }`}
        >
          {record.status}
        </span>
      ),
    },
    {
      title: "Details",
      key: "details",
      width: 100,
      fixed: "right",
      render: (text: any, record: any) => {
        const canView = allowedActions?.view;
        const canDelete = allowedActions?.cancel;
        return (
          <div
            className="details-cell"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "40px",
              gap: "8px",
            }}
          >
            {/* View Icon */}
            {canView && (
              <div className="view-hover-wrapper">
                <a
                  href={`#view-${record.userID}`}
                  className="btn btn-icon btn-trigger view-hover-icon"
                  id={`view-${record.userID}`}
                  onClick={(ev) => {
                    ev.preventDefault();
                    navigate(`${process.env.PUBLIC_URL}/userProfile/${record.userID}`);
                  }}
                >
                  <Icon name="focus"></Icon>
                </a>
                <TooltipComponent
                  id={`view-tooltip-${record.userID}`}
                  direction="top"
                  icon=""
                  text="View Details"
                  containerClassName=""
                  target={`view-${record.userID}`}
                  iconClass={undefined}
                />
              </div>
            )}

            {/* 3-dot menu with all actions */}
            {(canView || canDelete) && (
              <UncontrolledDropdown direction="start">
                <DropdownToggle
                  tag="button"
                  className="btn btn-sm btn-icon btn-light"
                  style={{
                    border: "none",
                    background: "none",
                    position: "relative",
                    zIndex: 1,
                    color: "#526484",
                  }}
                >
                  <Icon name="more-h" style={{ color: "inherit" }}></Icon>
                </DropdownToggle>
                <DropdownMenu
                  end
                  style={{
                    position: "fixed",
                    minWidth: "180px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    border: "1px solid #e5e5e5",
                    zIndex: 9999,
                    inset: "auto auto auto auto !important",
                  }}
                  container="body"
                >
                  <ul className="link-list-opt no-bdr" style={{ margin: 0 }}>
                    {canView && (
                      <li>
                        <DropdownItem
                          tag="a"
                          href={`#view-${record.userID}`}
                          onClick={(ev) => {
                            ev.preventDefault();
                            navigate(`${process.env.PUBLIC_URL}/userProfile/${record.userID}`);
                          }}
                          style={{
                            padding: "8px 16px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Icon name="focus" className="me-2" />
                          <span>View Details</span>
                        </DropdownItem>
                      </li>
                    )}

                    {canDelete && (
                      <li>
                        <DropdownItem
                          tag="a"
                          href={`#delete-${record.userID}`}
                          onClick={(ev) => {
                            ev.preventDefault();
                            handleDelete(record.userID);
                          }}
                          style={{
                            padding: "8px 16px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Icon name="trash" className="me-2" />
                          <span>Delete User</span>
                        </DropdownItem>
                      </li>
                    )}
                  </ul>
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <TransactionFlowDefaultTemplate
        moduleKey="users-list"
        title="Users"
        columns={columns}
        extra={{
          tableScrollX: 1700,
        }}
        refresh={refreshToggle}
        topRightJSX={
          allowedActions?.add ? (
            <Button color="primary" onClick={() => createUser()}>
              <Icon name="plus"></Icon>
              <span>Add </span>
            </Button>
          ) : (
            <></>
          )
        }
      />
    </>
  );
};

export default Users;
